module.exports = __webpack_public_path__ + "img/section1-parallax7.422c9d01.png";